module.exports = __webpack_public_path__ + "img/3e573ca.jpg";